import { Dna, Wrench, Sparkles, BarChart } from "lucide-react";

const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      icon: Dna,
      title: "Crie seu Product DNA",
      description: "Seu produto, seu público, suas dores, seu tom de voz. A IA entende tudo sobre o seu negócio.",
    },
    {
      number: 2,
      icon: Wrench,
      title: "Escolha um agente ou ferramenta",
      description: "+50 agentes especializados em SEO, copy, tráfego, vendas, conteúdo, etc.",
    },
    {
      number: 3,
      icon: Sparkles,
      title: "Deixe a IA construir com você",
      description: "Copy, anúncios, funis, análises, ideias — tudo em segundos, não horas.",
    },
    {
      number: 4,
      icon: BarChart,
      title: "Organize e acompanhe seu negócio",
      description: "Com planilhas inteligentes, central de dados, e desafios de implementação.",
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            🧠 Como Funciona
          </h2>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step) => (
              <div
                key={step.number}
                className="relative bg-card p-6 rounded-xl shadow-medium hover:shadow-lg transition-all hover:-translate-y-1"
              >
                {/* Step Number Badge */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold text-xl shadow-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="mb-4 mt-4">
                  <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                    <step.icon className="w-7 h-7 text-primary" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
